import React, { useEffect, useState } from 'react';
import { CnBalloon, CnBox, CnIcon } from '@cainiaofe/cn-ui';

import './index.scss';

const entryItems = [
  {
    label: '问题咨询',
    key: 'Q'
  },
  {
    label: '岗位推荐',
    key: 'P'
  }
];

let timer1 = null;
let timer2 = null;

const AiAssistantEntry = (props) => {
  const logo =
    'https://img.alicdn.com/imgextra/i2/O1CN01CC9nbM1uPnJ1D66A0_!!6000000006030-2-tps-240-240.png';
  const activeLogo =
    'https://img.alicdn.com/imgextra/i3/O1CN01nmiolM1iyoCDVENRA_!!6000000004482-2-tps-240-240.png';

  const { handleClickEntry } = props;

  const [isCollapsed, setIsCollapsed] = useState(true); // 默认收起
  const [isHover, setIsHover] = useState(false); // 鼠标是否在入口区域

  useEffect(() => {
    !isHover && showAnimation();
  }, [isCollapsed]);

  // 每隔10S自动变成展开模式，4S后用户未点击时收起
  const showAnimation = () => {
    if (isCollapsed) {
      timer1 = setTimeout(() => {
        setIsCollapsed(false);
      }, 10000);
    } else {
      timer2 = setTimeout(() => {
        setIsCollapsed(true);
      }, 4000);
    }
  };

  return (
    <div
      className="ai-assistant-entry-wrap"
      onClick={() => {
        setIsCollapsed(!isCollapsed);
      }}
      onMouseEnter={() => {
        setIsHover(true);
        clearTimeout(timer1);
        clearTimeout(timer2);
      }}
      onMouseLeave={() => {
        setIsHover(false);
        showAnimation();
      }}
    >
      <CnBalloon
        visible={!isCollapsed}
        align="t"
        offset={[-52, 0]}
        trigger={
          <div>
            <div className="ai-assistant-entry-robot">
              {isCollapsed ? (
                <img src={logo} width={80} />
              ) : (
                <img src={activeLogo} width={80} />
              )}
            </div>
          </div>
        }
        followTrigger
        closable={false}
        popupClassName="ai-assistant-entry-popup"
      >
        <CnBox align="center" justify="space-between" spacing={4}>
          {entryItems.map((item) => (
            <div
              className="ai-assistant-entry-item"
              key={item.key}
              onClick={() => handleClickEntry(item.key)}
            >
              {item.label}
            </div>
          ))}
        </CnBox>
      </CnBalloon>

      <div
        className={`ai-assistant-entry-square ${
          !isCollapsed ? 'entry-square-expand' : ''
        }`}
      >
        <CnIcon
          className="entry-square-arrow"
          type={isCollapsed ? 'arrow-left' : 'arrow-right'}
          size={'large'}
        />
      </div>
    </div>
  );
};

export default AiAssistantEntry;
